<template>
  <div class="main">
    <main>
      <div class="head">
        <div class="head1">
          <h1>{{data.major_name}}</h1>
          <p class="type">{{data.info.level1_name}}>{{data.major_category}}>{{data.major_type}}</p>
          <div><span>专业代码：{{data.info.spcode}}</span></div>

        </div>
      </div>
      <div class="content flex" style="align-items: flex-start;">
        <div class="left">
          <el-tabs class="tabs" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="专业简介" name="0">
              <div class="title">专业解释</div>
              <div class="introduction">
                <div>{{data.info.is_what}}</div>
              </div>
              <div class="title">学习内容</div>
              <div class="introduction">
                <div>{{data.info.course}}</div>
              </div>
              <div class="title">就业方向</div>
              <div class="introduction">
                <div>{{data.info.do_what}}</div>
              </div>
              <el-button type="warning" v-if="data.marked==false" icon="el-icon-star-off" @click="collect(0)">收藏
              </el-button>
              <el-button type="warning" v-else icon="el-icon-star-on" @click="collect(1)">已收藏</el-button>
              <div class="ratio flex">
                <div class="wenli">
                  <div class="title">文理比例</div>
                  <div class="ratio1 flex">
                    <div>
                      <p style="color: #333333;">文</p>
                      <div>{{data.info.arts_rate}}%</div>
                    </div>
                    <el-progress style="width: 220px;" :percentage="data.info.arts_rate" :show-text="false">
                    </el-progress>
                    <div>
                      <p style="background-color: #FFF5DA;color: #333333;">理</p>
                      <div>{{100-data.info.arts_rate}}%</div>
                    </div>
                  </div>
                </div>
                <div class="wenli">
                  <div class="title">男女比例</div>
                  <div class="ratio2 flex">
                    <el-progress :width="81" type="circle" :percentage="data.info.boy_rate"></el-progress>
                    <div>
                      <p style="margin-bottom: 28px;"><span class="circle"></span><span>男：{{data.info.boy_rate}}%</span>
                      </p>
                      <p><span class="circle1"></span><span>女：{{100-data.info.boy_rate}}%</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="year">
                <div class="title" style="width: 130px;">近三年就业率</div>
                <div class="ratio3 flex" v-if="data.info.jobrate!='[]'">
                  <div>
                    <el-progress :width="81" :format='format' type="circle" :percentage="jobrate[0].rate">
                    </el-progress>
                    <p>{{jobrate[0].rate}}</p>
                  </div>
                  <div>
                    <el-progress :width="81" :format='format1' type="circle" :percentage="jobrate[1].rate">
                    </el-progress>
                    <p>{{jobrate[1].rate}}</p>
                  </div>
                  <div>
                    <el-progress :width="81" :format='format2' type="circle" :percentage="jobrate[2].rate">
                    </el-progress>
                    <p>{{jobrate[2].rate}}</p>
                  </div>
                </div>
                <div v-else style="text-align: left;margin-top: 20px;">暂无数据</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="开设院校" name="1">
              <!-- 学校列表 -->
              <div class="schoolList" v-if="activeName == '1'">
                <div class="one flex" @click="goDetail(item)" v-for="(item,index) in school">
                  <div class="flex"> <img :src="'https://yunzhixuanpro.fw366.cn/' + item.badge_img">
                    <div class="info">
                      <div><span class="name">{{item.school_name}}</span></div>
                      <div class="type">
                        <span v-if="item.is_211==1">211</span>
                        <span v-if="item.is_985==1">985</span>
                        <span>{{item.edu_zn}}</span>
                        <span>{{item.type}}</span>
                        <span v-if="item.cate_zn!='综合类'">{{item.cate_zn}}</span>
                      </div>
                    </div>
                  </div>
                  <button type=" button">查看</button>
                </div>
              </div>
              <pagination :total='total' @currentchange='current_change'></pagination>
            </el-tab-pane>

            <!-- 职业 -->
            <el-tab-pane label="未来职业" name="2">
              <!-- 学校列表 -->
              <div class="schoolList" v-if="activeName == '2'&&career.length!=0">
                <div class="one flex" @click="goDetail(item,2)" v-for="(item,index) in career">
                  <div class="flex">
                    <div class="info">
                      <div><span class="name">{{item.name}}</span></div>
                      <div style="margin-top: 10px;">职业代码：<span>{{item.code}}</span></div>
                    </div>
                  </div>
                  <button type=" button">查看</button>
                </div>
              </div>
              <el-empty v-else :image-size="200"></el-empty>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 右侧边栏 -->
        <sidebar style="margin-left: 40px;"></sidebar>
      </div>
    </main>
  </div>
</template>

<script>
  import sidebar from '../../components/sidebar.vue'
  import pagination from '../../components/pagination.vue'
  export default {
    data() {
      return {
        activeName: "0",
        data: [],
        jobrate: [],
        school: [],
        total: '',
        career: []
      }
    },
    components: {
      sidebar,
      pagination
    },
    created() {
      this.$http.majorDetail({
        code: this.$route.query.id
      }).then(res => {
        this.data = res.data
        this.$http.majorCareers({
          id: res.data.id
        }).then(res => {
          this.career = res.data.list
        })
        if (res.data.info.jobrate != '[]') {
          this.jobrate = JSON.parse(res.data.info.jobrate)
          this.jobrate.forEach(item => {
            console.log(item.rate.indexOf('%'))
            item.rate = item.rate.slice(0, item.rate.indexOf('%'))
          })
        }
      })
      this.$http.majorSchools({
        code: this.$route.query.id
      }).then(res => {
        this.school = res.data.list
        this.total = res.data.total
      })


    },
    methods: {
      current_change(e) {
        this.$http.majorSchools({
          code: this.$route.query.id,
          page: e
        }).then(res => {
          this.school = res.data.list
          this.total = res.data.total
        })
      },
      collect(type) {
        this.$http.majorMark({
          major_id: this.data.id,
          cancel: type
        }).then(res => {
          this.$message.success('操作成功')
          this.$http.majorDetail({
            code: this.$route.query.id
          }).then(res => {
            this.data = res.data
            this.jobrate = JSON.parse(res.data.info.jobrate)
            this.jobrate.forEach(item => {
              console.log(item.rate.indexOf('%'))
              item.rate = item.rate.slice(0, item.rate.indexOf('%'))
            })
          })
        })
      },
      handleClick(tab) {
        this.activeName = tab.index
        console.log(this.activeName)
      },
      goDetail(item, num) {
        if (num == 2) {
          this.$router.push('/zhiyeDetail?id=' + item.id)
          return
        }
        this.$router.push('/schoolDetail?id=' + item.id)
      },
      format(percentage, num) {
        return this.jobrate[0].year
      },
      format1(percentage, num) {
        return this.jobrate[1].year
      },
      format2(percentage, num) {
        return this.jobrate[2].year
      }
    }
  }
</script>

<style scoped lang="scss">
  .year p {
    margin-top: 10px;
  }

  .one {
    justify-content: space-between;

    .info1 {
      margin-left: 68px;

      img {
        width: 20px;
        height: 20px;
        margin-top: 16px;
      }
    }

    text-align: left;
    border-bottom: 1px solid #F2F2F2;
    padding-bottom: 37px;
    margin-top: 30px;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;
      margin-left: 240px;
    }

    img {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .type {
      margin-top: 22px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 29px;
    }

    .address {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }

  .schoolList {
    margin: 40px 0;
  }

  .recommend {
    margin-left: 34px;
  }

  .list {

    // border: 1px solid #EDEDED;
    .name img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }

    ul {
      margin-top: 30px;
    }

    li {
      width: 100%;
      margin-bottom: 23px;
      text-align: left;
    }

    .hot {
      color: #FFA200;
      margin-left: 120px;
    }

    .rank {
      width: 20px;
      height: 20px;
      background: #FF0000;
      display: inline-block;
      color: #FFFFFF;
      line-height: 20px;
      text-align: center;
    }

    .rank1 {
      background: #FF7F7F;
    }

    .rank2 {
      background: #FFCCCC;
    }

    .rank3 {
      background: #F2F2F2;
    }
  }

  .ratio3 {
    width: 784px;
    height: 151px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05);
    border-radius: 10px;
    margin: 20px 2px;
    justify-content: space-around;
  }

  .ratio {
    margin-top: 45px;
    justify-content: space-between;

    .ratio2 {
      width: 364px;
      height: 113px;
      background: #FFFFFF;
      margin: 20px 2px;
      box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05);
      justify-content: space-around;
      border-radius: 10px;

      .circle {
        display: inline-block;
        margin-right: 6px;
        width: 10px;
        height: 10px;
        background: #C10B17;
        border-radius: 50%;
      }

      .circle1 {
        display: inline-block;
        margin-right: 6px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #FDCB48;
      }
    }

    .ratio1 {
      width: 364px;
      height: 113px;
      background: #FFFFFF;
      margin: 20px 2px;
      box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05);
      justify-content: space-around;
      border-radius: 10px;

      p {
        width: 50px;
        height: 50px;
        background: #D1F4F4;
        border-radius: 50%;
        line-height: 50px;
        margin-bottom: 8px;
        color: #C10B17;
      }
    }

    &>div {
      flex: 1;
    }
  }

  .more {
    width: 142px;
    height: 40px;
    background: #E8FAFA;
    border-radius: 20px;
    color: #C10B17;
    text-align: center;
    line-height: 40px;
    display: block;
    margin: 0 auto;
  }

  .introduction {
    line-height: 30px;
    text-align: left;
    margin: 20px 0 30px 0;
  }

  .title {
    color: #333333;
    font-weight: bold;
  }

  .left {
    width: 845px;
  }

  .tabs {
    margin-top: 28px;
  }

  .head {
    width: 1200px;
    height: 210px;
    background: url(../../assets/school/bg3.png)no-repeat;
    color: #FFFFFF;
    overflow: hidden;
    text-align: left;

    .type {
      margin: 20px auto;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }

    h1 {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      width: 468px;
      padding-bottom: 17px;
      border-bottom: 1px solid #FFFFFF;
    }

    .head1 {
      margin: 49px 0 0 24px;
    }
  }

  .main {
    width: 1200px;
    min-height: 1500px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/specialty/specialtyDetail.vue